import { Component } from '@angular/core';

/**
 * Settings > Data > Database Import & Export (mockup settings #database): Data Export, then Data
 * Import, on one page. Administrators only (the API refuses everyone else). The old /data-export
 * and /data-import URLs open this page.
 */
@Component({
    selector: 'app-data-exchange-page',
    template: `
        <app-settings-head url="/data-exchange"></app-settings-head>
        <section class="dxp-section" aria-labelledby="dataExportTitle">
            <h2 class="dxp-title" id="dataExportTitle">Export</h2>
            <app-data-export></app-data-export>
        </section>
        <section class="dxp-section" aria-labelledby="dataImportTitle">
            <h2 class="dxp-title" id="dataImportTitle">Import</h2>
            <app-data-import></app-data-import>
        </section>
    `,
    styles: [`
        :host { display: block; }
        .dxp-section + .dxp-section { margin-top: 32px; padding-top: 24px; border-top: 1px solid var(--im-line); }
        .dxp-title { margin: 0 0 16px; color: var(--im-ink); font-size: 22px; font-weight: 800; }
    `]
})
export class DataExchangePageComponent { }
